import { useCallback } from 'react';
import { useRouting } from '@alycecom/hooks';

export default url => {
  const go = useRouting();
  return useCallback(() => go(url), [go, url]);
};
